export const detectWeeklyOffIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete weeklyoff" || cleaned === "remove weeklyoff") {
        return { intent: "delete_weeklyoff" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) weeklyoff/);
    if (deleteMatch) {
        return { intent: "delete_weeklyoff", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create weeklyoff") || cleaned.includes("add weeklyoff")) {
        return { intent: "create_weeklyoff" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create weeklyoff named (.+)/);
    if (createMatch) {
        return { intent: "create_weeklyoff", name: createMatch[1].trim() };
    }

    return null;
};
